import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sbOpen: false,
    savvybotActiveSessionId: null,
    savvybotMessages: [],
  },
  reducers: {
    setSbOpen(state, action) {
      state.sbOpen = action.payload;
    },
    setSavvybotActiveSessionId(state, action) {
      state.savvybotActiveSessionId = action.payload;
    },
    setSavvybotMessages(state, action) {
      state.savvybotMessages = action.payload;
    },
    appendSavvybotMessage(state, action) {
      state.savvybotMessages.push(action.payload);
    },
    filterSavvybotMessage(state, action) {
      state.savvybotMessages = state.savvybotMessages.filter((m) => m.id !== action.payload);
    },
  },
});

export const {
  setSbOpen,
  setSavvybotActiveSessionId,
  setSavvybotMessages,
  appendSavvybotMessage,
  filterSavvybotMessage,
} = uiSlice.actions;

export const uiReducer = uiSlice.reducer;
